import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../hooks/useAuth';

const TrialBanner: React.FC = () => {
  const { user } = useAuth();
  const sub = user?.subscription;

  if (!sub || sub.status !== 'TRIAL') {
    return null;
  }

  const days = sub.trialDaysRemaining ?? null;
  const endsAt = sub.trialEndsAt
    ? new Date(sub.trialEndsAt).toLocaleDateString('es', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    : null;

  return (
    <div
      role="status"
      className="mb-4 flex flex-col gap-2 rounded-xl border border-indigo-200/80 bg-indigo-50 px-4 py-3 text-sm text-indigo-950 sm:flex-row sm:items-center sm:justify-between"
    >
      <div className="flex items-start gap-2">
        <ClockIcon className="mt-0.5 h-5 w-5 shrink-0 text-indigo-600" aria-hidden />
        <p>
          <span className="font-semibold">Periodo de prueba activo.</span>{' '}
          {days != null && days > 0 ? (
            <>
              Le quedan <strong>{days}</strong> día{days === 1 ? '' : 's'}
              {endsAt ? <> (hasta el {endsAt})</> : null}.
            </>
          ) : (
            <>Su prueba termina pronto{endsAt ? <> ({endsAt})</> : null}.</>
          )}{' '}
          Después podrá suscribirse desde Configuración.
        </p>
      </div>
      <Link
        to="/configuration"
        className="shrink-0 text-center text-xs font-semibold text-indigo-700 underline-offset-2 hover:underline sm:text-sm"
      >
        Ver planes
      </Link>
    </div>
  );
};

export default TrialBanner;
